import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'antd';

import Text from 'Pages/Home/Components/Atoms/Text';
import Styles from './NavCategoryItem.module.scss';
import { TNavCategoryItem } from './definitions';
import KALogo from 'images/ka-logo-black.png';
import { joinClassnames } from 'helpers/classNames';

const NavCategoryItem: React.FC<TNavCategoryItem> = ({title, onClick, mode, disabled, selected}) => {
  return (
    <Col onClick={disabled ? undefined : onClick}>
      {mode === 'image' ? (
        <KickImage src={KALogo} className={Styles['nav-logo']} />
      ) : (
        <Text
          className={
            disabled
              ? Styles['nav-item-disabled']
              : joinClassnames(
                  Styles['nav-item'],
                  selected && Styles['selected'],
                )
          }
        >
          {title}
        </Text>
      )}
      {selected && <div className={Styles['selected-box']} />}
    </Col>
  );
}

export default NavCategoryItem;